"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M5 5v6h6V5H5zM4 3a1 1 0 00-1 1v8a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1H4z"];
//# sourceMappingURL=small-square.js.map